import React from "react";
import { Breadcrumb } from "antd";

interface IProps {
  style?: React.CSSProperties;
  data: {
    value: string;
    url?: string;
  }[];
}

const Crumbs: React.FC<IProps> = ({ data, style }) => {
  return (
    <section className={`w-1180 text-[#333] mx-auto my-0 text-16 font-medium pt-20 flex items-center`} style={style}>
      您當前的位置：
      <Breadcrumb separator='>'>
        {Array.isArray(data) &&
          data.map((item) => (
            <React.Fragment key={item.value}>
              {item.url ? (
                <Breadcrumb.Item className='text-16 font-medium' href={item.url}>
                  <span className='text-[#333]'>{item.value}</span>
                </Breadcrumb.Item>
              ) : (
                <span className='text-[#333] text-16 font-medium'>{item.value}</span>
              )}
            </React.Fragment>
          ))}
      </Breadcrumb>
    </section>
  );
};
export default Crumbs;
